const RX_SCOPE = 'pg-prescription';
const PD_SCOPE = 'pg-pupillary-distance';
const PRESCRIPTION_STEP_FORM_ERROR_ID = 'prescription-step-form-error';
const PRESCRIPTION_STEP_UPLOAD_ERROR_ID = 'prescription-step-upload-error';
const PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID = 'prescription-step-upload-description';

export { PD_SCOPE, PRESCRIPTION_STEP_FORM_ERROR_ID, PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID, PRESCRIPTION_STEP_UPLOAD_ERROR_ID, RX_SCOPE };
//# sourceMappingURL=constants.js.map
